<div id="pageNotPermitted" class="container-fluid position-absolute" style="margin:0;padding:0;background:url(assets/images/fondo-azul.jpg) no-repeat center top;background-size:cover; height:100vh ">
    <!-- <div id="login"  style="height: 100vh;width:100vw;" [ngStyle]="{'background': 'url(assets/images/fondo-azul.jpg)'}"> -->
    <div class="account-pages mt-5 mb-5">
        <div class="container">
            <div class="row justify-content-center pb-0">
                <div class="col-md-10 col-lg-8 col-xl-6 login-spr px-0 pb-0">
                    <div class="card shadow-none ">
                        <div class="card-head p-3">
                            <div class="text-center w-100 m-auto align-middle">
                                <div class="text-center col-2 m-auto align-middle ">
                                    <img src="/assets/images/icons/cancel.svg">
                                </div>
                                <h1>
                                    No tienes permiso para acceder a este recurso</h1>
                            </div>
                        </div>
                        <div class="card-body p-3 ">
                            <div class="text-center w-75 m-auto align-middle">
                                <div class="row">
                                    <div>
                                        <h2>Clic <strong> <a href="#/admin/dashboard">aquí</a> </strong> para ir a la página principal </h2>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>